import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import axiosInstance from 'src/utils/axios';

export interface CancelInvoicesRequest {
  invoiceIds: number[];
}

interface UseCancelInvoicesMutationOptions {
  companyId?: string;
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

const useCancelInvoicesMutation = ({
  companyId,
  onSuccess,
  onError,
}: UseCancelInvoicesMutationOptions = {}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (invoiceIds: number[]) => {
      const response = await axiosInstance.post(api.cancelInvoice, invoiceIds);
      return response.data;
    },
    onSuccess: (data) => {
      // Invalidate invoice list queries to refetch updated data
      if (companyId) {
        queryClient.invalidateQueries({
          queryKey: queryKeys.invoice.list(companyId),
        });
      }
      queryClient.invalidateQueries({
        queryKey: queryKeys.invoice.root,
      });
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });

  return mutation;
};

export default useCancelInvoicesMutation;
